<template>
  <div class="trans-record-page">
    <van-nav-bar
      class="trans-nav"
      title="账户明细"
      left-arrow
      @click-left="$router.back()"
    />
    <div class="trans-nav-placeholder"></div>

    <div class="trans-content">
      <div class="saibox">
        <div class="sai" @click="showPopup(1)">{{ name }}</div>
        <div class="sai" @click="showPopup(2)">{{ dateName[date] }}</div>
        <div class="sai" @click="showPopup(3)">{{ typeName[type] }}</div>
      </div>

      <van-list
        v-if="list.length > 0"
        class="record-list"
        finished-text="没有更多了"
        offset="300"
        v-model="loading"
        :finished="list.length >= pageData.total"
        @load="getData"
      >
        <div class="record-card" v-for="(item, index) in list" :key="index">
          <div class="record-head">
            <span class="record-label">时间</span>
            <span class="record-value">{{ formatDateTime(item.created_at) }}</span>
          </div>
          <div class="record-row">
            <span class="record-label">交易类别</span>
            <span class="record-value">{{ item.trans_category || '-' }}</span>
          </div>
          <div class="record-row">
            <span class="record-label">交易额度</span>
            <span class="record-value record-money">{{ formatAmount(item.amount) }}</span>
          </div>
          <div class="record-row">
            <span class="record-label">摘要</span>
            <span class="record-value record-summary">{{ item.summary || '' }}</span>
          </div>
          <div class="record-row record-row-last">
            <span class="record-label">备注</span>
            <span class="record-value">{{ item.remark || '' }}</span>
          </div>
        </div>
      </van-list>

      <div v-else class="empty-box">
        <img src="/static/image/mescroll-empty.png" alt="" />
        <van-divider dashed :style="{ color: '#ccc', borderColor: '#ccc', padding: '20px' }">空空如也</van-divider>
      </div>
    </div>

    <van-popup v-model="popup" position="bottom" :style="{ height: 'calc(100% - 1.9rem - 46px)' }">
      <div class="lisg" v-if="showXuan == 1">
        <div class="bs" v-for="(item, index) in dogameLis" :key="index" @click="changDogame(item.name, item.platname)">
          <div :class="api_type == item.platname ? 'lisga act' : 'lisga'">{{ item.name }}</div>
        </div>
      </div>
      <div class="lisg" v-if="showXuan == 2">
        <div class="bs" @click="changtype('date', 1)">
          <div :class="date == 1 ? 'lisga act' : 'lisga'">今日</div>
        </div>
        <div class="bs" @click="changtype('date', 2)">
          <div :class="date == 2 ? 'lisga act' : 'lisga'">近7日</div>
        </div>
        <div class="bs" @click="changtype('date', 3)">
          <div :class="date == 3 ? 'lisga act' : 'lisga'">近15日</div>
        </div>
        <div class="bs" @click="changtype('date', 4)">
          <div :class="date == 4 ? 'lisga act' : 'lisga'">近30日</div>
        </div>
      </div>
      <div class="lisg" v-if="showXuan == 3">
        <div class="bs" @click="changtype('type', 1)">
          <div :class="type == 1 ? 'lisga act' : 'lisga'">存款</div>
        </div>
        <div class="bs" @click="changtype('type', 2)">
          <div :class="type == 2 ? 'lisga act' : 'lisga'">取款</div>
        </div>
        <div class="bs" @click="changtype('type', 3)">
          <div :class="type == 3 ? 'lisga act' : 'lisga'">转入</div>
        </div>
        <div class="bs" @click="changtype('type', 4)">
          <div :class="type == 4 ? 'lisga act' : 'lisga'">转出</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'transRecord',
  data() {
    return {
      date: 4,
      list: [],
      pageData: {},
      type: 1,
      page: 1,
      dogameLis: [],
      api_type: '',
      loading: false,
      name: '全平台',
      dateName: ['', '今日', '近7日', '近15日', '近30日'],
      typeName: ['', '存款', '取款', '转入', '转出'],
      popup: false,
      showXuan: 1,
    };
  },
  created() {
    this.getdogame();
    this.getData();
  },
  methods: {
    formatAmount(value) {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return '0.00';
      }
      const prefix = num < 0 ? '-' : '';
      const text = Math.abs(num).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return prefix + text;
    },
    formatDateTime(value) {
      if (!value) {
        return '';
      }
      const text = String(value);
      if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(text)) {
        return text;
      }
      const date = new Date(text);
      if (Number.isNaN(date.getTime())) {
        return text.replace('T', ' ').replace(/\.\d+Z?$/, '').replace(/Z$/, '');
      }
      const pad = n => String(n).padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    changDogame(name, type) {
      this.name = name;
      this.api_type = type;
      this.popup = false;
      this.page = 1;
      this.list = [];
      this.pageData = {};
      this.getData();
    },
    changtype(name, val) {
      this[name] = val;
      this.popup = false;
      this.page = 1;
      this.list = [];
      this.pageData = {};
      this.getData();
    },
    showPopup(val) {
      this.popup = true;
      this.showXuan = val;
    },
    getdogame() {
      this.$apiFun.post('/api/balancelist', {}).then(res => {
        if (res.code == 200) {
          this.dogameLis = res.data;
          this.dogameLis.unshift({ name: '全平台', platname: '' });
        }
      });
    },
    getData() {
      const page = this.page;
      if (this.pageData.last_page && page > this.pageData.last_page) {
        this.loading = false;
        return;
      }
      this.$parent.showLoading();
      const info = {
        date: this.date,
        type: this.type,
        page: this.page,
        api_type: this.api_type,
      };
      this.$apiFun
        .post('/api/gettransrecord', info)
        .then(res => {
          if (res.code != 200) {
            this.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            this.pageData = res.data;
            if (page == 1) {
              this.list = res.data.data || [];
            } else {
              this.list = this.list.concat(res.data.data || []);
            }
            this.page = page + 1;
          }
          this.loading = false;
          this.$parent.hideLoading();
        })
        .catch(() => {
          this.$parent.hideLoading();
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.trans-record-page {
  width: 100%;
  min-height: 100vh;
  background: #f3f3f3;
  box-sizing: border-box;
}

.trans-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #ede9e7;
  z-index: 10;
}

.trans-nav-placeholder {
  height: 46px;
}

.trans-content {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px 30px;
}

.saibox {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 1.1rem;
  box-sizing: border-box;
  padding: 0 4px;
  margin-bottom: 12px;

  .sai {
    height: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
    background: #fff;
    border-radius: 1.1rem;
    font-size: 0.3rem;
    color: #333;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }
}

.record-list {
  padding-bottom: 30px;
}

.record-card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
}

.record-head,
.record-row {
  display: flex;
  align-items: flex-start;
  min-height: 42px;
  padding: 10px 14px;
  border-bottom: 1px solid #ececec;
  box-sizing: border-box;
}

.record-head {
  background: #f7f7f7;
}

.record-row-last {
  border-bottom: none;
}

.record-label {
  width: 78px;
  flex-shrink: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.record-value {
  flex: 1;
  font-size: 14px;
  color: #222;
  line-height: 1.5;
  word-break: break-all;
}

.record-money {
  font-weight: 700;
}

.record-summary {
  color: #333;
}

.empty-box {
  margin-top: 60px;
  text-align: center;

  img {
    width: 35%;
  }
}

.lisg {
  box-sizing: border-box;
  padding: 10px 8px;
  display: flex;
  flex-wrap: wrap;

  .bs {
    width: 25%;
    height: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;

    .lisga {
      width: calc(100% - 8px);
      height: 0.9rem;
      border: 0.02rem solid #cbced8;
      border-radius: 0.08rem;
      color: #a5a9b3;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.2rem;
      text-align: center;
    }

    .lisga.act {
      background: #cf866b;
      color: #fff;
      border: none;
    }
  }
}
</style>
